import { createAsyncThunk } from "@reduxjs/toolkit";
import { campaignService } from "../../services";

export const fetchCampaigns = createAsyncThunk(
  'campaign/fetchCampaigns',
  async (_, { rejectWithValue }) => {
    const response = await campaignService.fetchCampaigns()
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return response;
  }
)